import { css, Global } from '@emotion/react'

const global = css`
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400;1,600;1,700&display=swap');

  .chakra-text .chakra-link {
    text-decoration: underline;
  }
`

export const GlobalStyles = () => <Global styles={global} />
